<template>
  <v-app>
        <div id="dvLoading" class="loading">
          <div class="img-loading" style="text-align: center">
            <img
              src="./assets/spinner.gif"
              style="width: 51px; height: 51px"
              alt=""
            />
            <span style="display: block; color: #a1bbc2; font: bold 9px">
              CARREGANDO
            </span>
          </div>
        </div>
        <Header />
        <v-main>
          <router-view />
        </v-main>
        <Footer />
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  created() {
    this.$eventBus.$on(this.$const.EVENT_SHOW_LOADING, () => {
      document.getElementById('dvLoading').style.display = 'flex';
      document.getElementById('dvLoading').style.alignItems = 'center';
      document.getElementById('dvLoading').style.justifyContent = 'center';
    });

    this.$eventBus.$on(this.$const.EVENT_REMOVE_LOADING, () => {
      document.getElementById('dvLoading').style.display = 'none';
    });
  },
};
</script>
